import { render, staticRenderFns } from "./FarmHistoricalData.vue?vue&type=template&id=2e7dba1e"
import script from "./FarmHistoricalData.vue?vue&type=script&lang=js"
export * from "./FarmHistoricalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports